const constants = {
  pdfFileType: 'application/pdf',
  organizePDF: 'Organize PDF',
  onlyPdfAllowed: 'Only PDF files are allowed',
  organizationFailed: 'Organization failed. Please try again.',
  unsupportedFileType: 'Unsupported file type. Please upload only pdfs',
  success: 'Success',
  limitExceeded: 'Limit Exceeded',
  cancel: 'Cancel',
  uploadFile: 'Upload file',
  onlyPdfSupported: 'Only PDF format is supported',
  pageOrder: 'Page Order',
  dragToReorder: 'Drag to reorder, click rotate button to rotate pages',
  choose: 'Choose',
  chooseFiles: 'Choose files',
  dropFileToUpload: 'Drop file to upload',
  dropFilesToUpload: 'Drop files to upload',
  showFewerFiles: 'Show fewer files',
  showMoreFiles: 'Show more files',
  error: 'Error',
  addNumbers: 'Add Numbers',
  addPageNumbers: 'Add Page Numbers',
  addingNumbersFailed: 'Adding numbers failed. Please try again.',
  position: 'Position',
  choosePosition: 'Choose where to place page numbers',
  topLeft: 'Top Left',
  topRight: 'Top Right',
  bottomLeft: 'Bottom Left',
  bottomRight: 'Bottom Right',
  currentSize: 'Current size:',
  mb: 'MB',
  totalMaxLimit: 'Total maximum limit: 2GB',
  signPDF: 'Sign PDF',
  signingFailed: 'Signing failed. Please try again.',
  enterSignatureText: 'Please enter signature text',
  signature: 'Signature',
  enterSignature: 'Enter your name or signature text',
  signaturePosition: 'Signature Position',
  chooseSignaturePosition: 'Choose where to place the signature',
  enterYourSignature: 'Enter your signature',
  addWatermark: 'Add Watermark',
  watermarkingFailed: 'Watermarking failed. Please try again.',
  enterWatermarkText: 'Please enter watermark text',
  watermarkText: 'Watermark Text',
  enterTextForWatermark: 'Enter text for watermark',
  enterWatermarkTextPlaceholder: 'Enter watermark text',
  opacity: 'Opacity',
  chooseWatermarkTransparency: 'Choose watermark transparency',
  PdfToPngText: 'Convert PDF pages to PNG images online',
  erroredFile: 'Please select a valid PDF file.',
  pdfFile: 'Please select a PDF file.',
  convert: 'Convert',
  conversionFailed: 'Conversion failed',
  lowResolution: 'Low resolution (faster)',
  mediumResolution: 'Medium resolution (recommended)',
  highResolution: 'High resolution (larger files)',
  processing: 'Processing...',
  pdfToPng: 'PDF to PNG',
  pdfToPngConverter: 'PDF to PNG Converter',
  imageQuality: 'Image Quality',
  outputResolution: 'Choose output image resolution',
  disabled: 'disabled',
  low: 'low',
  medium: 'medium',
  high: 'high',
  encryptedFile: 'The uploaded file is encrypted. Please decrypt and try again.',
  processingCancelled: 'Conversion cancelled by user',
  pdfToWord: 'PDF to Word',
  convertToWord: 'Convert to Word',
  conversionSuccessful: 'PDF converted to Word document successfully!',
  noTextFound: 'No text found in PDF. The PDF might contain only images or be encrypted.',
  conversionFailedWord: 'Conversion failed. Please try again or check if the PDF is encrypted.',
};

export default constants;
